// Behavior-level. No threshold formulas or parsing internals.

export default {
  title: 'Discrepancy Checker',
  summary:
    'Compare reporting numbers between two parties — or run a full Supply \u2192 Ad Server \u2192 Demand three-way chain check — to find where impressions and revenue diverge.',

  sections: [
    {
      h: 'What this tool does',
      p: [
        "Takes two sides' numbers — say an SSP versus a DSP — and computes the discrepancy per row, flagging gaps as warnings or critical based on how large they are.",
        'It also supports a three-way chain — supply, ad server, demand — so you can see *where* in the path the numbers break, not just that they don\u2019t match. Numbers can come in by hand, by file (CSV / XLSX), or pulled from a report URL.',
      ],
    },
    {
      h: 'When to use it',
      list: [
        "Month-end reconciliation — your number and a partner's number don't agree and you need to quantify and locate the gap.",
        'You suspect the discrepancy is concentrated at one hop of the chain and want to prove it.',
      ],
    },
    {
      h: 'How to use it',
      steps: [
        '**Set the two parties and their roles** (one supply, one demand) — or turn on the three-way chain and name the supply, ad server, and demand sources.',
        '**Add the numbers** — type rows, upload files, or point at a report URL.',
        '**Run the check** and read the summary: total rows, criticals, warnings.',
        '**Drill into the flagged rows** to see the size and direction of each gap.',
      ],
    },
    {
      callout:
        "A discrepancy isn't automatically a problem — some gap between two systems' counting is normal. The check flags by magnitude, so use the critical / warning split to focus on the gaps that actually matter.",
    },
  ],

  faqs: [
    {
      q: 'Two-way vs three-way?',
      a: 'Two-way compares one side against another. Three-way places an ad server in the middle, so you can tell whether the gap is supply\u2192ad-server or ad-server\u2192demand.',
    },
    {
      q: 'What counts as critical?',
      a: "Larger relative gaps are flagged critical, smaller ones warning — so a rounding-level difference doesn't drown out a real one.",
    },
  ],
};
